import {Injectable, OnDestroy} from '@angular/core';
import {GlobalService} from '../global/global.service';
import {UserWsInfo} from './model/user-ws-info';
import {ChatStatusInfo} from './model/chat-status.info';
import {ChatWsStateService} from './chat-ws-state.service';
import {Permissions} from '../auth/permissions';
import {Module} from '../model/profile';
import {Subject, Subscription} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {ReconnectingSocket} from './reconnecting-socket';

const isWebview = require("is-ua-webview");

const MESSAGE_COUNT_TOPIC = `/users/chat/chat-status`;
const CHAT_WS_ENDPOINT = `/app/chat-ws`;

const RECONNECT_TIMEOUT = 60000;
const THROTTLE_TIME = 1000;

@Injectable({
  providedIn: 'root'
})
export class ChatWebSocketService implements OnDestroy {

  private socket: ReconnectingSocket;

  private debouncedUpdate = new Subject<void>();
  private debouncedUpdateSubs: Subscription;

  constructor(private globalService: GlobalService,
              private chatWsStatusService: ChatWsStateService) {

    this.socket = new ReconnectingSocket({
      hiddenReconnectDelay: RECONNECT_TIMEOUT,
      canConnect: () => Permissions.hasModule(Module.MANAGEMENT) && !isWebview(navigator.userAgent),
      fetchUserInfo: () => this.globalService.userChatWsInfo(),
      headers: (userInfo: UserWsInfo) => ({
        employeeId: userInfo.employeeId,
        clientId: userInfo.clientId,
        token: userInfo.token,
        accountId: userInfo.accountId,
        partner: userInfo.partner,
        zoneId: userInfo.zoneId
      }),
      onConnected: () => this.socket.subscribe(MESSAGE_COUNT_TOPIC, (event) =>
        this.handleMessageCount(JSON.parse(event.body))
      ),
      onResume: () => this.sendUpdateSubedVehicle()
    });

    this.debouncedUpdateSubs = this.debouncedUpdate
      .pipe(debounceTime(THROTTLE_TIME))
      .subscribe(() => this.sendUpdateSubedVehicle());
  }

  public getUserAndConnect(): void {
    this.socket.connect();
  }

  public updateSubedVehicles(): void {
    this.debouncedUpdate.next();
  }

  public sendUpdateSubedVehicle(): void {
    this.socket.send(CHAT_WS_ENDPOINT);
  }

  public disconnect(): void {
    this.socket.disconnect();
  }

  public ngOnDestroy(): void {
    this.debouncedUpdateSubs.unsubscribe();
    this.socket.destroy();
  }

  private handleMessageCount = (chatStatus: ChatStatusInfo) => {
    this.chatWsStatusService.notifyMessageCount({
      textMessageCount: chatStatus.textMessageCount,
      fileMessageCount: chatStatus.fileMessageCount
    });
    this.chatWsStatusService.notifyCountByVehicleSource(chatStatus.countByVehicle);
    this.chatWsStatusService.notifyChatStatus(chatStatus.displayInfos);
  };

}
